export default "__VITE_ASSET__7caef2b5__"